{
	"main": {
		"titleAktivnosti": "DANAŠNJE AKTIVNOSTI V ZRAKU",
		"subtitleAktivnosti": "AKTIVNOSTI NA IZBRAN DATUM"
	},
	"labels": {
		"datum": "Datum aktivnosti:"
	},
	"aktivnosti": {
		"title": "Pregled aktivnosti za datum",
		"opozorila": "OPOZORILA",
		"cas": "Čas:",
		"vnesel": "Vnesel:",
		"mainTitle": "RAZPORED LETENJA"
	},
	"razpored": {
		"titleJ": "Jadralna letala",
		"titleM": "Motorna letala",
		"titleUL": "UltraLight letala",
		"let": "Let",
		"planirano": "Planirano:",
		"naloga": "Naloga:",
		"sredstvo": "Sredstvo:",
		"vrstaLetala": "Vrsta letala:",
		"izvrsilec": "Izvršilec pregleda letala:",
		"podpis": "Podpis:"
	},
	"obvestila": {
		"brisiSredstvo": "Ali res želiš izbrisati sredstvo?",
		"vnosUspesen": "vnos uspešen",
		"vnosNeuspesen": "Napaka pri pridobivanju podatkov.",
		"nepricakovanaNapaka": "Prišlo je do nepričakovane napake",
		"poslano": "Sporočilo poslano",
		"niPoslano": "Sporočilo ni bilo poslano"
	}
}